Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var _reactNativeSafeAreaContext = require("react-native-safe-area-context");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    spacing = _STYLES$useStyles.spacing,
    sizing = _STYLES$useStyles.sizing;
  var insets = (0, _reactNativeSafeAreaContext.useSafeAreaInsets)();
  var _containerTop = sizing.topBarHeight + insets.top;
  var container = {
    paddingTop: (0, _styles.getREM)(_containerTop / _styles.baseSize),
    marginBottom: spacing.xxl,
    width: '100%'
  };
  var header = {
    paddingTop: (0, _styles.getREM)(_containerTop / _styles.baseSize),
    paddingBottom: (0, _styles.getREM)(sizing.headerPaddingBottom / _styles.baseSize),
    marginTop: (0, _styles.getREM)(-_containerTop / _styles.baseSize),
    width: '100%',
    overflow: 'hidden'
  };
  var content = {
    paddingRight: spacing.page.padding.paddingRight,
    paddingLeft: spacing.page.padding.paddingLeft
  };
  var backgroundContainer = Object.assign({}, _reactNative.StyleSheet.absoluteFillObject);
  var styles = _reactNative.StyleSheet.create({
    container: container,
    header: header,
    content: content,
    backgroundContainer: backgroundContainer
  });
  return {
    styles: styles
  };
};